import * as React from "react";
import ContentCard from "../content-card/content-card";
import {
  AskAboutQuery_SourceData,
  AskAboutQuery_Tip,
} from "../../../../graphql-types";
import SourceLink from "../source-link/source-link";
import CardContent from "../content-card/card-content";
import { EventCategory } from "../../../utils/analytics";
import styles from "./text-answer.styles";
import TextAnswerTip from "./text-answer-tip";
import AnswerFlag from "./answer-flag";

interface TextAnswerProps {
  intentName: string;
  answerIndex: number;
  title?: string;
  content: string[];
  tip?: AskAboutQuery_Tip;
  sources?: AskAboutQuery_SourceData[] | null;
}

const TextAnswer: React.FC<TextAnswerProps> = ({
  intentName,
  answerIndex,
  title,
  content,
  tip,
  sources,
}) => {
  return (
    <ContentCard>
      <CardContent isNarrow={true}>
        {!!title && <h2 css={styles.heading}>{title}</h2>}
        <div
          css={styles.content}
          className="content"
          dangerouslySetInnerHTML={{
            __html: content.join(""),
          }}
        />
        {!!tip && <TextAnswerTip {...tip} />}

        {sources && (
          <SourceLink
            sources={sources}
            eventCategory={EventCategory.Section_TextAnswer}
          />
        )}
      </CardContent>

      <AnswerFlag
        intentName={intentName}
        answerIndex={answerIndex}
        answerType="text"
      />
    </ContentCard>
  );
};

export default TextAnswer;
